import { endpoints } from "../../../configs/Settings";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";
import { HTTPResponseStatus } from "../../../utils/enum";
import {  IVetPatientData } from "../../../utils/interfaces";
import { OAuthApplication } from "../../auth";

export async function PostVetPatient(objData: IVetPatientData) {
  const url = `${endpoints.VETPATIENT}/Patient`;

  const bearerToken = await OAuthApplication();
  const data = auxiliarData.VetPatient(objData);
  const headers = {
    Accept: "application/fhir+json",
    Authorization: bearerToken,
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .post(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PostPatient: ${response.status}`);
      }
      return { status: HTTPResponseStatus.Created, data: response.data };
    })
    .catch((error) => {
      console.error("PostPatient ", error);
      // toast.error(`PostPatient Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
